import React from "react";
import { cn } from "@/lib/utils";

export const PageHeader = ({ title, subtitle, actions, className, icon: Icon }) => (
  <div className={cn("flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between", className)}>
    <div className="flex items-start gap-3">
      {Icon && (
        <span className="mt-0.5 grid h-10 w-10 place-items-center rounded-lg bg-primary-soft text-primary">
          <Icon className="h-5 w-5" />
        </span>
      )}
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-foreground sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
